import { useEffect, useState } from 'react';
import { api } from '../../api/client';

interface Terminal {
  id: string;
  description: string | null;
  seller_group_id: number;
  active: boolean;
}

interface ApiData {
  data?: Terminal[];
}

export function TerminalSelector({ onSelected }: { onSelected: (id: string) => void }) {
  const [terminals, setTerminals] = useState<Terminal[]>([]);
  const [selected, setSelected] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    api.get<ApiData>('/wh-terminals').then((r) => {
      if (cancelled) return;
      if (r.success) setTerminals((r.data as any) || []);
      else setError(r.error || 'Error loading terminals');
      setLoading(false);
    });
    return () => {
      cancelled = true;
    };
  }, []);

  const confirm = () => {
    if (!selected) return;
    localStorage.setItem('cbt_terminal_id', selected);
    onSelected(selected);
  };

  return (
    <div className="fixed inset-0 bg-black/60 z-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-2xl p-8 max-w-md w-full">
        <h2 className="text-2xl font-bold mb-2">Identificate</h2>
        <p className="text-gray-600 mb-6">¿En qué mesa de packing estás trabajando?</p>

        {loading && <p className="text-gray-500">Cargando terminales...</p>}
        {error && <p className="text-red-600">Error: {error}</p>}
        {!loading && terminals.length === 0 && (
          <p className="text-orange-600 mb-4">
            No hay terminales registradas. Pedile a un admin que las cree en Settings → Print Agent.
          </p>
        )}

        {terminals.length > 0 && (
          <>
            <select
              value={selected}
              onChange={(e) => setSelected(e.target.value)}
              className="w-full border rounded p-2 mb-4"
            >
              <option value="">— Elegir mesa —</option>
              {terminals.map((t) => (
                <option key={t.id} value={t.id}>
                  {t.id}
                  {t.description ? ` — ${t.description}` : ''}
                </option>
              ))}
            </select>
            <button
              onClick={confirm}
              disabled={!selected}
              className="w-full bg-blue-600 text-white p-2 rounded disabled:bg-gray-300"
            >
              Confirmar
            </button>
            <p className="text-xs text-gray-500 mt-4">
              Tu elección queda guardada en este browser. Si cambiás de mesa, abrí Settings → cambiar terminal.
            </p>
          </>
        )}
      </div>
    </div>
  );
}
